import { BaseService } from "../Base/BaseService";
import { globalData } from "../globals";

const SOURCE_KEY = "looksty_source";
const FIRST_SOURCE_KEY = "looksty_first_source";
const SESSION_ID_KEY = "looksty_session_id";

const ALLOWED_SOURCES = new Set(["feed", "feed_details", "search", "master_profile", "master_dashboard", "user_masters", "profile", "collection", "share", "direct"]);

type AnalyticsPayload = {
  eventType: string;
  source?: string;
  entityType?: string;
  entityId?: number;
  metadata?: Record<string, unknown>;
};

export class AnalyticsClient extends BaseService {
  private static isAdmin() {
    return globalData.CurrentUser?.role === "admin";
  }
  private static getSessionId() {
    let value = sessionStorage.getItem(SESSION_ID_KEY);

    if (!value) {
      value = crypto.randomUUID();
      sessionStorage.setItem(SESSION_ID_KEY, value);
    }

    return value;
  }

  private static normalizeSource(source?: string | null) {
    if (source && ALLOWED_SOURCES.has(source)) {
      return source;
    }

    return "direct";
  }

  private static setSources(source?: string | null) {
    const normalizedSource = this.normalizeSource(source);

    if (!sessionStorage.getItem(FIRST_SOURCE_KEY)) {
      sessionStorage.setItem(FIRST_SOURCE_KEY, normalizedSource);
    }

    sessionStorage.setItem(SOURCE_KEY, normalizedSource);

    return {
      source: normalizedSource,
      firstSource: sessionStorage.getItem(FIRST_SOURCE_KEY) ?? normalizedSource,
    };
  }

  private static getSources(source?: string | null) {
    if (source) {
      return this.setSources(source);
    }

    const currentSource = sessionStorage.getItem(SOURCE_KEY);
    const firstSource = sessionStorage.getItem(FIRST_SOURCE_KEY);

    return {
      source: this.normalizeSource(currentSource),
      firstSource: this.normalizeSource(firstSource),
    };
  }

  private static shouldUseFirstSource(eventType: string) {
    return ["booking_created", "booking_confirmed", "booking_completed", "booking_cancelled"].includes(eventType);
  }

  public static async track(payload: AnalyticsPayload) {
    if (this.isAdmin()) return;
    try {
      const sources = this.getSources(payload.source);

      const source = this.shouldUseFirstSource(payload.eventType) ? sources.firstSource : sources.source;

      await BaseService.post(BaseService.BaseApiUrl + "/analytics/events", {
        ...payload,
        source,
        metadata: {
          ...(payload.metadata ?? {}),
          firstSource: sources.firstSource,
          currentSource: sources.source,
        },
        sessionId: this.getSessionId(),
      });
    } catch {
      // аналитику не ломаем пользователю
    }
  }
}
